<div *ngIf="progress > 0" class="file-upload__progress-bar">
    <mat-progress-bar class="file-upload__progress-bar__bar" [value]="progress"></mat-progress-bar>
    <div class="file-upload__progress-value">{{ progress }}%</div>
</div>
